import { create } from "zustand";
import { retrieveFeaturesData, updateFeaturesData } from "./actions";

type DataStoreProps = {
    loading                : boolean    
    data                   : { [key:string]:any} | null
    retrieveData    : () => void
    updateData             : (data:any) => Promise<void>
    error                  : string  
}

export const useFeatureStore = create<DataStoreProps>( (set,getState) => ({
    data: null,
    loading: false,
    error: "",
    retrieveData() {
        set( state => ({loading: true, error: ""}))
        retrieveFeaturesData()
            .then( data => set( state => ({data:data, loading:false})))
            .catch( err => set(state => ({loading:false, error:err})))
    },
    async updateData(data) {
        try {
            await updateFeaturesData(data)
            set(state => ({ data: data, error: "" }))
        } catch (error: any) {
            const message = error?.message ?? "Failed updating data"
            set(state => ({ error: message }))
            throw error
        }
    },
}))
